<template>
    <div class="sidebar">
        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar" data-widget="treeview" role="menu" data-accordion="false">
                <TheNodeTreeMenu v-for="menu in treeData" :key="menu.id" :node="menu"></TheNodeTreeMenu>
                <li class="nav-item">
                    <a class='nav-link nav-nav' href="https://db.sadec.dongthap.gov.vn" target="_blank">
                        <i class="nav-icon fas fa-tachometer-alt"></i>
                        <p>Dashboard IOC</p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class='nav-link nav-nav' href="/file/HDSD/HDSD_CSDLRDP.pdf" download="HDSD_CSDLRDP.pdf">
                        <i class="nav-icon fas fa-book"></i>
                        <p>Hướng dẫn sử dụng</p>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import TheNodeTreeMenu from '@/components/dashboard/TheNodeTreeMenu.vue';
import objectDefaultValue from '@/config/object.env'
import axios from 'axios';
export default {
    name: 'TheTreeMenu',
    props: {
        treeData: Object
    },
    components: {
        TheNodeTreeMenu
    },
    methods: {
        async downloadImportSampleFile() {
            let filename = 'HDSD_CSDLRDP.pdf';
            let pathFile = objectDefaultValue.GUIDE_FILE_PATH + filename;
            try {
                const response = await axios.get(pathFile, {
                    responseType: 'blob', // Khai báo kiểu dữ liệu là blob.
                });

                // Tạo một đường dẫn tạm thời và tạo ra một liên kết ẩn để tải xuống.
                const tempUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = tempUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();

                // Giải phóng đường dẫn tạm thời sau khi tải xuống hoàn tất.
                window.URL.revokeObjectURL(tempUrl);
            } catch (error) {
                console.error('Lỗi khi tải tập tin:', error);
            }
        },
    },
    async mounted() {
    }
};
</script>

<style>
</style>